import React, { useEffect, useRef, useState } from 'react';

const TopProgressBar = ({ active }) => {
  const [visible, setVisible] = useState(false);
  const hideTimerRef = useRef(null);

  useEffect(() => {
    if (hideTimerRef.current) {
      clearTimeout(hideTimerRef.current);
      hideTimerRef.current = null;
    }

    if (active) {
      setVisible(true);
      return undefined;
    }

    hideTimerRef.current = setTimeout(() => {
      setVisible(false);
      hideTimerRef.current = null;
    }, 520);

    return () => {
      if (hideTimerRef.current) {
        clearTimeout(hideTimerRef.current);
        hideTimerRef.current = null;
      }
    };
  }, [active]);

  return (
    <div
      className={`page-progress-bar ${visible ? 'page-progress-bar--active' : ''}`}
      aria-hidden={!visible}
    >
      <div className="page-progress-bar__track" />
    </div>
  );
};

export default TopProgressBar;
